import { useHotkeys } from 'react-hotkeys-hook';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { SHORTCUT_PLAYBACK_RATES } from '../constants/playbackRate';
import { usePlayerPlaybackChange } from './usePlayerPlaybackChange';

export type UsePlayerPlaybackRateShortcutParams = {
  /**
   * The scope for the playback rate shortcut.
   * @see https://github.com/JohannesKlauss/react-hotkeys-hook?tab=readme-ov-file#scopes
   */
  scope: string;
};

export const usePlayerPlaybackRateShortcut = ({ scope }: UsePlayerPlaybackRateShortcutParams) => {
  const initialized = usePlayerStore((store) => store.initialized);
  const playbackRate = usePlayerStore((store) => store.playbackRate);
  const { onPlayerPlaybackChange } = usePlayerPlaybackChange();

  useHotkeys(
    'l',
    () => {
      const currentIndex = SHORTCUT_PLAYBACK_RATES.indexOf(playbackRate);
      const defaultIndex = SHORTCUT_PLAYBACK_RATES.indexOf(1);
      const nextIndex =
        currentIndex === -1 ? defaultIndex + 1 : Math.min(currentIndex + 1, SHORTCUT_PLAYBACK_RATES.length - 1);
      const nextPlaybackRate = SHORTCUT_PLAYBACK_RATES[nextIndex];

      onPlayerPlaybackChange(nextPlaybackRate);
    },
    {
      description: 'Increase playback rate',
      enabled: initialized,
      preventDefault: true,
      scopes: [scope],
    },
    [initialized, playbackRate, scope, onPlayerPlaybackChange],
  );

  useHotkeys(
    'j',
    () => {
      const currentIndex = SHORTCUT_PLAYBACK_RATES.indexOf(playbackRate);
      const defaultIndex = SHORTCUT_PLAYBACK_RATES.indexOf(1);
      const nextIndex = currentIndex === -1 ? defaultIndex - 1 : Math.max(currentIndex - 1, 0);
      const nextPlaybackRate = SHORTCUT_PLAYBACK_RATES[nextIndex];

      onPlayerPlaybackChange(nextPlaybackRate);
    },
    {
      description: 'Decrease playback rate',
      enabled: initialized,
      preventDefault: true,
      scopes: [scope],
    },
    [initialized, playbackRate, scope, onPlayerPlaybackChange],
  );
};
